import { useTasks } from 'features/tasks';
import { useMemo } from 'react';

export const useTextFilteredTasks = (searchText: string) => {
  const tasks = useTasks(undefined, !!searchText);

  return useMemo(() => {
    if (!searchText) {
      return [];
    }
    const trimmedSearchText = searchText.trim().toLowerCase();

    return tasks
      .filter(
        ({ name, description }) =>
          name.toLowerCase().includes(trimmedSearchText) ||
          description?.toLowerCase().includes(trimmedSearchText),
      )
      .sort(
        (taskA, taskB) =>
          (taskA.completedAt ? 1 : 0) - (taskB.completedAt ? 1 : 0) ||
          new Date(taskA.createdAt).getTime() -
            new Date(taskB.createdAt).getTime(),
      );
  }, [searchText, tasks]);
};
